<div class="dialog-header">
  <h3>
    <ng-container>{{ "confirm-vehicle-arrival" | translate }}</ng-container>
  </h3>
  <button
    class="close-button"
    mat-icon-button
    tabindex="-1"
    cdkFocusInitial
    (click)="closeDialog(false)"
  >
    <i class="bosch-ic bosch-ic-clickable bosch-ic-close"></i>
  </button>
</div>

<div class="dialog-content">
  <form [formGroup]="form">
    <div class="row-fx-legacy">
      <mat-form-field>
        <mat-label>{{ "input-completion-prediction" | translate }}</mat-label>
        <input
          matInput
          [matDatepicker]="minDatePicker"
          formControlName="date"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="minDatePicker"
        ></mat-datepicker-toggle>
        <mat-datepicker #minDatePicker></mat-datepicker>
        <mat-error
          translate
          *ngIf="
            form.get('date').touched && form.get('date').hasError('required')
          "
          >{{ "required-completion-prediction" | translate }}</mat-error
        >
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ "label-period" | translate }}</mat-label>
        <mat-select formControlName="period">
          <mat-option *ngFor="let period of periods" [value]="period.value">
            {{ period.name | uppercase }}
          </mat-option>
        </mat-select>
        <mat-error
          *ngIf="
            form.get('period').touched &&
            form.get('period').hasError('required')
          "
          >{{ "required-shift" | translate }}</mat-error
        >
      </mat-form-field>
    </div>

    <div style="margin-bottom: 6px">
      {{
        (serviceType == "CORRECTIVE"
          ? "corrective-maintenance-finish-date"
          : "preventive-pneus-maintenance-finish-date"
        ) | translate
      }}
    </div>

    <div class="row-fx-legacy">
      <mat-form-field class="mat-form-field-margin">
        <mat-label>{{
          "input-current-km" | translate : { mileageUnit: mileageUnit }
        }}</mat-label>
        <input
          formControlName="carWorkshopKm"
          matInput
          [mask]="getOnlyNumbersMask()"
          (input)="checkMinValue()"
          maxlength="9"
        />
        <mat-error
          *ngIf="
            form.get('carWorkshopKm').touched &&
            form.get('carWorkshopKm').hasError('required')
          "
          >{{ "required-km" | addCountryCode | translate }}</mat-error
        >
        <mat-error
          *ngIf="
            form.get('carWorkshopKm').touched &&
            form.get('carWorkshopKm').hasError('isGreatherThanCurrentKm')
          "
          >{{ "required-km-minimum" | addCountryCode | translate }}
          {{ currentKm }} km</mat-error
        >
      </mat-form-field>
    </div>

    <div style="margin-bottom: 6px">
      {{ "input-current-date" | translate : { mileageUnit: mileageUnit } }}
    </div>

    <div class="row-fx-legacy">
      <mat-form-field class="mat-form-field-margin">
        <mat-label>{{
          "arrival-date" | translate : { mileageUnit: mileageUnit }
        }}</mat-label>
        <input
          matInput
          [matDatepicker]="arrivalDatePicker"
          formControlName="arrivalDate"
          (dateChange)="validaDate()"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="arrivalDatePicker"
        ></mat-datepicker-toggle>
        <mat-datepicker #arrivalDatePicker></mat-datepicker>

        <mat-error *ngIf="form.get('arrivalDate').hasError('required')">
          {{ "find-carworkshop-maps.required-field" | translate }}
        </mat-error>

        <mat-error
          *ngIf="form.get('arrivalDate').hasError('isGreaterThanCurrentDate')"
        >
          {{ "future-date-input-current-date" | translate }}
        </mat-error>
      </mat-form-field>

      <mat-form-field class="mat-form-field-margin">
        <mat-label>{{ "input-current-date" | translate }}</mat-label>
        <input
          class="time-custom"
          formControlName="arrivalTime"
          matInput
          type="time"
          maxlength="5"
          (change)="validaDate()"
        />

        <mat-error *ngIf="form.get('arrivalTime').hasError('required')">
          {{ "find-carworkshop-maps.required-field" | translate }}
        </mat-error>
      </mat-form-field>
    </div>
  </form>
</div>
<div class="dialog-warning" *ngIf="canShowWarning">
  <span class="span-warning">
    {{ "label-with-items-to-verify" | translate }}
  </span>
</div>
<div class="dialog-actions">
  <button
    [disabled]="form.invalid"
    mat-raised-button
    color="primary"
    (click)="closeDialog(true)"
  >
    {{ "input-save" | translate }}
  </button>
  <button mat-button (click)="closeDialog(false)">
    {{ "input-cancel" | translate }}
  </button>
</div>
